import React, {useContext, useEffect, useState} from "react";
import {View, StyleSheet, TouchableOpacity, TextInput} from "react-native";
import PtIcon from "../core/pt-icon/pt-icon";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import {useDispatch, useSelector} from "react-redux";
import {getImpersonationSearchResults} from "../../actions/impersonationActions";
import {ImpersonationSearchRequest} from "../../model/ImpersonationSearchRequest";
import UserContext from "../../helpers/UserContext";
import {useNavigation} from "@react-navigation/native";
import PtActivityIndicator from "../core/pt-activity-indicator/pt-activity-indicator";
import {getTranslation} from "../../helpers/getTranslation";
import Logout from "../core/logout/logout";
import {resetReduxOnImpersonation} from "../../actions/customerDataActions";
import {getOrderTypesFromApi, resetOrderTypesOnImpersonation} from "../../actions/orderTypeActions";

export default function PtImpersonationModal(props: any) {

  /** filters display configuration per country **/
  const filtersPerCountry = {
    ar: ['customerNumber', 'customerName', 'city', 'taxNr'],
    br: ['customerNumber', 'customerName', 'city', 'taxNr'],
    cl: ['customerNumber', 'customerName', 'city', 'taxNr'],
    co: ['customerNumber', 'customerName', 'city', 'taxNr'],
    ec: ['customerNumber', 'customerName', 'city', 'taxNr'],
    la: ['customerNumber', 'customerName', 'city', 'taxNr'],
    pe: ['customerNumber', 'customerName', 'city', 'taxNr'],
    uy: ['customerNumber', 'customerName', 'city', 'taxNr']
  }

  /** labels **/
  const customerNumberLabel = getTranslation('impersonation.customer.number.label') || 'Customer #';
  const customerNameLabel = getTranslation('impersonation.customer.name.label') || 'Customer name';
  const cityLabel = getTranslation('impersonation.city.label') || 'City';
  const taxNumberLabel = getTranslation('impersonation.tax.number.label') || 'Tax number';
  const payerNumberLabel = getTranslation('impersonation.payer.number.label') || 'Payer #';
  const payerNameLabel = getTranslation('impersonation.payer.name.label') || 'Payer name';
  const searchButtonLabel = getTranslation('impersonation.search.button.label') || 'Search';
  const viewAsMeLabel = getTranslation('impersonation.view.as.me.label') || 'View as me';
  const hideAdvancedFiltersLabel = getTranslation('impersonation.hide.advanced.filters.label') || 'Hide advanced filters';
  const showAdvancedFiltersLabel = getTranslation('impersonation.show.advanced.filters.label') || 'Show advanced filters';
  const viewAsButtonLabel = getTranslation('impersonation.view.as.button.label') || 'View as';
  const noResultsFoundLabel = getTranslation('impersonation.no.results.found.label') || 'No results found';

  const navigation = useNavigation();
  const dispatch = useDispatch();

  const [searchResults, setSearchResults] = useState([]);

  const [customerNumberSearchValue, setCustomerNumberSearchValue] = useState('');
  const [customerNameSearchValue, setCustomerNameSearchValue] = useState('');
  const [citySearchValue, setCitySearchValue] = useState('');
  const [taxNrSearchValue, setTaxNrSearchValue] = useState('');
  const [payerNumberSearchValue, setPayerNumberSearchValue] = useState();
  const [payerNameSearchValue, setPayerNameSearchValue] = useState();

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const [initialDataCollected, setInitialDataCollected] = useState(false);
  const [loading, setLoading] = useState(false);
  const isAuthenticated: any = useSelector((state: any) => state.authReducer.isAuthenticated);

  const {userData, updateUserData} = useContext(UserContext);
  const PTBaseSiteUID = userData.baseSiteUID;
  const salesAreaDependentCustomerUid = userData.salesAreaDependantCustomerUid;
  useEffect(() => {
    if(isAuthenticated && !initialDataCollected) {
      const searchRequest = new ImpersonationSearchRequest();
        searchRequest.baseSiteUid = PTBaseSiteUID;
      setLoading(true);
      getImpersonationSearchResults(searchRequest, PTBaseSiteUID, salesAreaDependentCustomerUid).then((results) => {
        setSearchResults(results);
      }).catch((error) => {
        setSearchResults([]);
        console.log('there was an error collecting results from impersonation search api', error);
      }).finally(() => {
        console.log('impersonation search request finally');
        setLoading(false);
        setInitialDataCollected(true);
      })
    }
  }, [isAuthenticated]);

  const searchCustomerNumberChanged = (newVal:any) => {
    const searchTerm = newVal.trim() == '' ? null : newVal;
    setCustomerNumberSearchValue(searchTerm);
  }

  const toggleAdvancedFilters = () => {
    setShowAdvancedFilters(!showAdvancedFilters);
  }

  const searchCustomerNameChanged = (newVal:any) => {
    setCustomerNameSearchValue(newVal);
  }

  const searchCityChanged = (newVal:any) => {
    setCitySearchValue(newVal);
  }

  const searchTaxNrChanged = (newVal:any) => {
    setTaxNrSearchValue(newVal);
  }

  const searchPayerNumberChanged = (newVal:any) => {
    setPayerNumberSearchValue(newVal);
  }

  const searchPayerNameChanged = (newVal:any) => {
    setPayerNameSearchValue(newVal);
  }


  const performSearch = () => {
    console.log('Sad treba da trigerujemo request sa search parametrima');
    const searchRequest = new ImpersonationSearchRequest(
      customerNumberSearchValue,
      customerNameSearchValue,
      citySearchValue,
      taxNrSearchValue,
      payerNumberSearchValue,
      payerNameSearchValue,
      userData.baseSiteUID
    );
    setLoading(true);
    getImpersonationSearchResults(searchRequest, PTBaseSiteUID,salesAreaDependentCustomerUid).then((results:any) => {
      console.log('the results from impersonations search are = ', results);
      setSearchResults(results);
    }).catch((error) => {
      setSearchResults([]);
      console.log('error while fetching impersonation search data', error);
    }).finally(() => {
      setLoading(false);
    })
  }


  const impersonateCustomer = async (customerData:any) => {
    updateUserData({
      ...userData,
      impersonatingId: customerData.customerId,
      impersonatingUid: customerData.customerUid,
      impersonatingName: customerData.customerName,
      salesAreaDependantCustomerUid: customerData.salesAreaDependentCustomerUid,
      resetTxtUpload: true,
      resetXlsUpload: true,
      resetCustomerUpload: true
    });
    await resetReduxOnImpersonation(dispatch);
    await getOrderTypesFromApi(dispatch, customerData.salesAreaDependentCustomerUid);
    navigation.goBack();
  }

  const stopImpersonation = async () => {
    console.log('stopping impersonation');
    updateUserData({
      ...userData,
      impersonatingId: null,
      impersonatingUid: null,
      impersonatingName: null,
      salesAreaDependantCustomerUid: null,
      resetTxtUpload: true,
      resetXlsUpload: true,
      resetCustomerUpload: true
    });
    await resetReduxOnImpersonation(dispatch);
    dispatch(resetOrderTypesOnImpersonation());
    navigation.goBack();
  }

  const renderCustomerNumberFilter = () => {
    return filtersPerCountry[PTBaseSiteUID]?.indexOf('customerNumber') >= 0 ?
      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchCustomerNumberChanged(text)}
          value={customerNumberSearchValue}
          placeholder={customerNumberLabel}
        />
      </View>
      : null
  }

  const renderCustomerNameFilter = () => {
    return filtersPerCountry[PTBaseSiteUID]?.indexOf('customerName') >= 0 ?
      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchCustomerNameChanged(text)}
          value={customerNameSearchValue}
          placeholder={customerNameLabel}
        />
      </View>
      : null
  }

  const renderCityFilter = () => {
    return filtersPerCountry[PTBaseSiteUID]?.indexOf('city') >= 0 ?
      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchCityChanged(text)}
          value={citySearchValue}
          placeholder={cityLabel}
        />
      </View>
      : null
  }

  const renderTaxNrFilter = () => {
    return filtersPerCountry[PTBaseSiteUID]?.indexOf('taxNr') >= 0 ?
      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchTaxNrChanged(text)}
          value={taxNrSearchValue}
          placeholder={taxNumberLabel}
        />
      </View>
      : null
  }

  const renderPayerNumberFilter = () => {
    return filtersPerCountry[PTBaseSiteUID]?.indexOf('payerNumber') >= 0 ?
      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchPayerNumberChanged(text)}
          value={payerNumberSearchValue}
          placeholder={payerNumberLabel}
        />
      </View>
      : null
  }

  const renderPayerNameFilter = () => {
    return filtersPerCountry[PTBaseSiteUID]?.indexOf('payerName') >= 0 ?
      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchPayerNameChanged(text)}
          value={payerNameSearchValue}
          placeholder={payerNameLabel}
        />
      </View>
      : null
  }

  return(
    <View style={[styles.impersonationContainer]}>

      <PtActivityIndicator show={loading}/>

      <View style={[styles.impersonationSearchContainer]}>
        <View>
          <View style={[styles.filtersAndSwitchContainer]}>
            <View style={[styles.toggleAdvancedFiltersContainer]}>
              <TouchableOpacity onPress={() => toggleAdvancedFilters()}>
                <View style={[styles.toggleAdvancedFiltersButton]}>
                  {showAdvancedFilters ?
                    <PtIcon iconName={`up`} iconColor={styleVars.boschBlue40} />
                    :
                    <PtIcon iconName={`down`} iconColor={styleVars.boschBlue40} />
                  }
                  <PtText style={[styles.toggleAdvancedFiltersLabel]}>
                    {showAdvancedFilters ? `${hideAdvancedFiltersLabel}` : `${showAdvancedFiltersLabel}`}
                  </PtText>
                </View>
              </TouchableOpacity>
            </View>
            <View style={[styles.toggleImpersonationButtonContainer]}>
              {userData.impersonatingId && !userData.mustImpersonate ?
                <TouchableOpacity onPress={() => stopImpersonation()}>
                  <View style={[styles.toggleImpersonationButton]}>
                    <PtIcon iconName={`watch-off-disabled-light`} iconColor={styleVars.boschBlue40} />
                    <PtText style={[styles.toggleImpersonationButtonLabel]}>{viewAsMeLabel}</PtText>
                  </View>
                </TouchableOpacity>
                :
                <View style={[styles.toggleImpersonationButton]}>
                  <PtIcon iconName={`watch-off-disabled-light`} iconColor={styleVars.boschGray70} />
                  <PtText style={[styles.toggleImpersonationButtonLabel, {color: styleVars.boschGray70}]}>{viewAsMeLabel}</PtText>
                </View>
              }
            </View>
          </View>

          {showAdvancedFilters ?
            <View style={[styles.advancedFiltersContainer]}>

              {renderCustomerNameFilter()}

              {renderCityFilter()}

              {renderTaxNrFilter()}

              {renderPayerNumberFilter()}

              {renderPayerNameFilter()}

            </View>
            : null
          }
        </View>

        <View style={[styles.advancedFiltersContainer]}>

          {renderCustomerNumberFilter()}

          <View style={[styles.applyFiltersContainer]}>
            <TouchableOpacity onPress={() => performSearch()}>
              <View style={[styles.applyFiltersButton]}>
                <PtText style={[styles.applyFiltersButtonText]}>
                  {searchButtonLabel}
                </PtText>
              </View>
            </TouchableOpacity>
          </View>
        </View>

        {initialDataCollected ?

          <View style={[styles.searchResultsContainer]}>
            {searchResults?.length > 0 ?
              searchResults.map((searchResult: any, idx: number) => (
                <View style={styles.searchResultItem} key={idx}>
                  <View>
                    <PtText style={[styles.resultCustomerNumber]}>
                      {searchResult.customerId}
                    </PtText>
                  </View>
                  <View>
                    <PtText style={[styles.resultCustomerName]}>
                      {searchResult.customerName}
                    </PtText>
                  </View>
                  <View>
                    <PtText style={[styles.resultAddress]}>
                      {searchResult.customerAddress}
                    </PtText>
                  </View>

                  <View>
                    <PtText style={[styles.resultRegion]}>
                      {searchResult.region} {searchResult.postalCode}
                    </PtText>
                  </View>

                  <View>
                    <PtText style={[styles.resultDistrict]}>
                      {searchResult.district}
                    </PtText>
                  </View>
                  <View>
                    <TouchableOpacity onPress={() => impersonateCustomer(searchResult)}>
                      <View style={[styles.impersonateButton]}>
                        <PtIcon iconName={`watch-on`} iconColor={styleVars.boschWhite}/>
                        <PtText style={[styles.impersonateButtonText]}>
                          {viewAsButtonLabel}
                        </PtText>
                      </View>
                    </TouchableOpacity>
                  </View>
                </View>
              ))
              :
              <View style={styles.noResultsMessageContainer}>
                <PtText>
                  {noResultsFoundLabel}
                </PtText>
              </View>
            }
          </View>
          : null
        }

      </View>

      <View style={styles.logoutButtonContainer}>
        <Logout/>
      </View>

    </View>
  )


}

const styles = StyleSheet.create({
  impersonationSearchContainer: {},
  impersonationContainer: {
    paddingVertical: styleVars.rem(.5),
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  salesRepSearchHeader: {},
  salesRepSearchHeaderText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
    color: styleVars.boschDarkBlue
  },
  searchInputContainer: {
    paddingVertical: styleVars.rem(.5)
  },
  impersonationSearchLabel: {
    fontWeight: 'bold',
  },
  searchInput: {
    height: 48,
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: styleVars.boschBlack,
    backgroundColor: styleVars.boschGray90,
    paddingRight: 16,
    paddingLeft: 16,
    fontSize: styleVars.rem(1),
  },

  advancedFiltersContainer: {
    paddingVertical: styleVars.rem(.5),
    paddingHorizontal: styleVars.rem(.5),
    borderBottomWidth: 1,
    borderBottomColor: styleVars.boschGray70,
  },

  filtersAndSwitchContainer: {
    backgroundColor: styleVars.boschGray90,
    height: 48,
    paddingHorizontal: styleVars.rem(.25),
    paddingVertical: styleVars.rem(.25),
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  toggleAdvancedFiltersContainer: {
    flex: 1,
  },

  toggleImpersonationButtonContainer: {
    flex: 1,
  },

  toggleAdvancedFiltersButton: {
    flexDirection:'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
  },

  toggleAdvancedFiltersLabel: {
    color: styleVars.boschBlue40,
    paddingHorizontal: styleVars.rem(.25),
  },

  toggleImpersonationButton: {
    flexDirection:'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1,
  },

  toggleImpersonationButtonLabel: {
    color: styleVars.boschBlue40,
    paddingHorizontal: styleVars.rem(.25),
  },

  applyFiltersContainer: {
    justifyContent: 'center',
    width: '100%',
  },
  applyFiltersButton: {
    marginVertical: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.5),
    paddingHorizontal: styleVars.rem(1),
    borderWidth: 1,
    borderColor: styleVars.boschBlue50,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    flexGrow: 0
  },
  applyFiltersButtonText: {
    color: styleVars.boschBlue50,
  },

  searchResultsContainer: {
    paddingVertical: styleVars.rem(1),
  },

  searchResultItem: {
    borderBottomWidth: 1,
    borderBottomColor: styleVars.boschGray70,
    marginVertical: styleVars.rem(.25),
    padding: styleVars.rem(.5),
  },

  resultCustomerNumber: {
    fontSize: styleVars.rem(.75),
    paddingBottom: styleVars.rem(.25),
  },
  resultCustomerName: {
    fontWeight: 'bold',
    paddingBottom: styleVars.rem(.5),
  },
  resultAddress: {
    paddingBottom: styleVars.rem(.5),
  },
  resultRegion: {
    fontSize: styleVars.rem(.875),
    paddingBottom: styleVars.rem(.25),
  },
  resultDistrict: {
    fontSize: styleVars.rem(.875),
    paddingBottom: styleVars.rem(.5),
  },
  impersonateButton: {
    marginVertical: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.5),
    paddingHorizontal: styleVars.rem(1),
    borderWidth: 0,
    borderColor: styleVars.boschDarkBlue,
    flexDirection: "row",
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: styleVars.boschBlue50,
    flexGrow: 0
  },
  impersonateButtonText: {
    color: styleVars.boschWhite,
    paddingHorizontal: styleVars.rem(.5),
  },
  logoutButtonContainer: {
    borderTopWidth: 1,
    borderTopColor: styleVars.boschGray70,
    marginVertical: styleVars.rem(1),
    alignItems: "flex-end"
  },
  noResultsMessageContainer: {
    paddingVertica: styleVars.rem(.5),
    justifyContent: "center",
    alignItems: "center"
  }


});
